<template>
<a :href="`/blog/${data.custom_url}`">
  <div class="card-container">
    <img :src="data.cover" :alt="data.title">
    <div class="card-bottom">
      <h3 class="blog-title mb-1">{{ data.title }}</h3>
      <p class="mb-5 post-desc">{{ data.description_meta_tag }}</p>
    </div>
    <a :href="`/blog/${data.custom_url}`" class="read-more">Leer mas...</a>
  </div>
</a>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    computed: {
      phone() {
        return `https://wa.me/52${this.data.phone}?text=${this.data.whatsapp_text ?? ''}`
      }
    }
  }
</script>

<style scoped>
  .card-container {
    display: flex; 
    flex-direction: column; 
    background-color: #fff;
    width: 100%;
    height: 380px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    justify-content: space-between;
    padding-bottom: 10px;
  }

  img {
    width: 100%;
    height: 200px;
    display: block;
    object-fit: cover;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .card-bottom {
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .card-bottom > * {
    font-size: 18px;
    font-weight: 500;
  }

  .card-bottom > h3:hover {
    color: #DBFE54;
  }

  .card-bottom > h3 {
    font-weight: bold;
    font-size: 1rem;
  }

  .card-bottom > p {
    width: 100%;
    font-size: 0.8rem;
/*     white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis; */
  }

  .read-more {
    font-size: 0.8rem;
    text-decoration: underline;
    margin-left: 15px;
  }

</style>